// Stripe client helpers. All sensitive logic lives in edge functions.
import { supabase } from "@/integrations/supabase/client";

export type CheckoutArgs = {
  priceId: string;
  mode?: "subscription" | "payment";
  featureKey?: string;
  successUrl?: string;
  cancelUrl?: string;
};

/** Start a Stripe Checkout flow. Opens the session URL in a new tab. */
export async function startCheckout(args: CheckoutArgs): Promise<void> {
  const { data, error } = await supabase.functions.invoke("create-checkout", {
    body: {
      price_id: args.priceId,
      mode: args.mode ?? "subscription",
      feature_key: args.featureKey,
      success_url: args.successUrl,
      cancel_url: args.cancelUrl,
    },
  });
  if (error) throw error;
  const url = (data as { url?: string })?.url;
  if (!url) throw new Error("No checkout URL returned");
  window.open(url, "_blank");
}

/** Open the Stripe Billing Portal so the user can manage/cancel. */
export async function openCustomerPortal(returnUrl?: string): Promise<void> {
  const { data, error } = await supabase.functions.invoke("customer-portal", {
    body: { return_url: returnUrl },
  });
  if (error) throw error;
  const url = (data as { url?: string })?.url;
  if (!url) throw new Error("No portal URL returned");
  window.open(url, "_blank");
}

export type SubscriptionState = {
  subscribed: boolean;
  subscription_status?: string | null;
  subscription_tier?: string | null;
  current_period_end?: string | null;
};

/** Force-refresh the user's subscription state from Stripe. */
export async function refreshSubscription(): Promise<SubscriptionState> {
  const { data, error } = await supabase.functions.invoke("check-subscription");
  if (error) throw error;
  return data as SubscriptionState;
}
